import "./index.css";
import React from "react";
import { render } from "react-dom";
import { App } from "./App";
import { initMetaPixel } from "./utils/metaPixel";
initMetaPixel();
render(<App data-id="element-357" data-mp="1wcxurqhwnagd" />, document.getElementById("root"));